import React from 'react';
interface SectionProps {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'white' | 'tint' | 'deep';
  width?: 'content' | 'narrow';
  children: React.ReactNode;
}
const toneClasses: Record<NonNullable<SectionProps['tone']>, string> = {
  white: 'bg-white text-gray-900',
  tint: 'bg-gray-50 text-gray-900',
  deep: 'bg-gray-900 text-white'
};
export function Section({
  id,
  eyebrow,
  title,
  intro,
  tone = 'white',
  width = 'content',
  children
}: SectionProps) {
  const hasHeader = Boolean(eyebrow || title || intro);
  return <section id={id} className={`w-full py-16 md:py-24 ${toneClasses[tone]}`} data-id="element-214" data-mp="2q4ya8dw6mhc">
      <div className={`mx-auto w-full px-5 md:px-8 ${width === 'narrow' ? 'max-w-4xl' : 'max-w-5xl'}`} data-id="element-215" data-mp="2o0wbvzjzxjp">
        {hasHeader && <header className="mx-auto max-w-4xl text-center" data-id="element-216" data-mp="vdhn6p7iz6dt">
            {eyebrow && <p className={`mb-4 text-xs font-bold uppercase tracking-widest ${tone === 'deep' ? 'text-blue-300' : 'text-blue-600'}`} data-id="element-217" data-mp="105itzvlxc4wg">
                {eyebrow}
              </p>}
            {title && <h2 className="text-3xl font-extrabold leading-tight tracking-tight md:text-5xl" data-id="element-218" data-mp="38df9ho86twgu">
                {title}
              </h2>}
            {intro && <p className={`mx-auto mt-5 max-w-2xl text-lg md:text-xl ${tone === 'deep' ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-219" data-mp="3ib35ehhj5a0l">
                {intro}
              </p>}
          </header>}
        <div className={hasHeader ? 'mt-12 md:mt-16' : ''} data-id="element-220" data-mp="3r9nhgzsl4lfu">{children}</div>
      </div>
    </section>;
}